/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Collections_Errors_Notfound1Inputs */

const id_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksi tidak ditemukan`)
};

const ms_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksi tidak ditemui`)
};

const da_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samling ikke fundet`)
};

const de_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammlung nicht gefunden`)
};

const en_us2_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collection not found`)
};

const es_es2_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colección no encontrada`)
};

const es_mx2_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colección no encontrada`)
};

const fil_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nahanap ang koleksyon`)
};

const fr_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collection non trouvée`)
};

const it_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collezione non trovata`)
};

const hu_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyűjtemény nem található`)
};

const nl_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collectie niet gevonden`)
};

const no_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samling ikke funnet`)
};

const pl_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolekcja nie znaleziona`)
};

const pt_br2_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coleção não encontrada`)
};

const pt_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coleção não encontrada`)
};

const ro_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colecție negăsită`)
};

const fi_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokoelmaa ei löydy`)
};

const sv_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlingen hittades inte`)
};

const vi_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy bộ sưu tập`)
};

const tr_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksiyon bulunamadı`)
};

const cs_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolekce nenalezena`)
};

const bg_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колекцията не е намерена`)
};

const ru_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подборка не найдена`)
};

const uk_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колекцію не знайдено`)
};

const ar_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجموعة غير موجودة`)
};

const hi_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कलेक्शन नहीं मिला`)
};

const th_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบคอลเล็กชัน`)
};

const ja_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コレクションが見つかりません`)
};

const zh_cn2_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合集未找到`)
};

const zh_hant1_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合集未找到`)
};

const ko_collections_errors_notfound1 = /** @type {(inputs: Collections_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컬렉션을 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "Collection not found" |
*
* @param {Collections_Errors_Notfound1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_errors_notfound1 = /** @type {((inputs?: Collections_Errors_Notfound1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Errors_Notfound1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_errors_notfound1(inputs)
	if (locale === "ms") return ms_collections_errors_notfound1(inputs)
	if (locale === "da") return da_collections_errors_notfound1(inputs)
	if (locale === "de") return de_collections_errors_notfound1(inputs)
	if (locale === "en-US") return en_us2_collections_errors_notfound1(inputs)
	if (locale === "es-ES") return es_es2_collections_errors_notfound1(inputs)
	if (locale === "es-MX") return es_mx2_collections_errors_notfound1(inputs)
	if (locale === "fil") return fil_collections_errors_notfound1(inputs)
	if (locale === "fr") return fr_collections_errors_notfound1(inputs)
	if (locale === "it") return it_collections_errors_notfound1(inputs)
	if (locale === "hu") return hu_collections_errors_notfound1(inputs)
	if (locale === "nl") return nl_collections_errors_notfound1(inputs)
	if (locale === "no") return no_collections_errors_notfound1(inputs)
	if (locale === "pl") return pl_collections_errors_notfound1(inputs)
	if (locale === "pt-BR") return pt_br2_collections_errors_notfound1(inputs)
	if (locale === "pt") return pt_collections_errors_notfound1(inputs)
	if (locale === "ro") return ro_collections_errors_notfound1(inputs)
	if (locale === "fi") return fi_collections_errors_notfound1(inputs)
	if (locale === "sv") return sv_collections_errors_notfound1(inputs)
	if (locale === "vi") return vi_collections_errors_notfound1(inputs)
	if (locale === "tr") return tr_collections_errors_notfound1(inputs)
	if (locale === "cs") return cs_collections_errors_notfound1(inputs)
	if (locale === "bg") return bg_collections_errors_notfound1(inputs)
	if (locale === "ru") return ru_collections_errors_notfound1(inputs)
	if (locale === "uk") return uk_collections_errors_notfound1(inputs)
	if (locale === "ar") return ar_collections_errors_notfound1(inputs)
	if (locale === "hi") return hi_collections_errors_notfound1(inputs)
	if (locale === "th") return th_collections_errors_notfound1(inputs)
	if (locale === "ja") return ja_collections_errors_notfound1(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_errors_notfound1(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_errors_notfound1(inputs)
	return ko_collections_errors_notfound1(inputs)
});
export { collections_errors_notfound1 as "collections.errors.notFound" }